module.exports = __webpack_public_path__ + "static/media/stick4.73da76b6.png";